package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Kazakhstan Flag (16x12dp)
 *
 * - ISO Alpha-2: KZ
 * - ISO Alpha-3: KAZ
 * - ISO Numeric: 398
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Kazakhstan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Kazakhstan:KZ:KAZ:398:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4EC7EE)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(2.045f, 11.618f)
                curveTo(2.013f, 11.854f, 2.164f, 12.021f, 2.416f, 12.129f)
                curveTo(2.756f, 12.273f, 3.098f, 12.138f, 3.413f, 11.789f)
                lineTo(3.005f, 11.42f)
                curveTo(2.865f, 11.575f, 2.764f, 11.635f, 2.686f, 11.634f)
                curveTo(2.839f, 11.525f, 3.035f, 11.39f, 3.273f, 11.23f)
                lineTo(3.388f, 11.064f)
                curveTo(3.48f, 10.669f, 3.194f, 10.456f, 2.758f, 10.456f)
                curveTo(2.501f, 10.456f, 2.295f, 10.507f, 2.165f, 10.616f)
                curveTo(1.951f, 10.795f, 1.988f, 11.082f, 2.213f, 11.231f)
                curveTo(2.231f, 11.243f, 2.249f, 11.253f, 2.267f, 11.263f)
                curveTo(2.141f, 11.37f, 2.064f, 11.48f, 2.045f, 11.618f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFFFFE402)),
                strokeLineWidth = 0.55f
            ) {
                moveTo(2.282f, 11.248f)
                curveTo(2.282f, 11.248f, 2.345f, 11.109f, 2.314f, 11.038f)
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(4.285f, 11.618f)
                curveTo(4.317f, 11.854f, 4.166f, 12.021f, 3.913f, 12.129f)
                curveTo(3.574f, 12.273f, 3.232f, 12.138f, 2.916f, 11.789f)
                lineTo(3.325f, 11.42f)
                curveTo(3.465f, 11.575f, 3.566f, 11.635f, 3.644f, 11.634f)
                curveTo(3.491f, 11.525f, 3.295f, 11.39f, 3.057f, 11.23f)
                lineTo(2.942f, 11.064f)
                curveTo(2.85f, 10.669f, 3.136f, 10.456f, 3.572f, 10.456f)
                curveTo(3.829f, 10.456f, 4.034f, 10.507f, 4.165f, 10.616f)
                curveTo(4.379f, 10.795f, 4.342f, 11.082f, 4.117f, 11.231f)
                curveTo(4.099f, 11.243f, 4.081f, 11.253f, 4.063f, 11.263f)
                curveTo(4.189f, 11.37f, 4.266f, 11.48f, 4.285f, 11.618f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(4.298f, 11.135f)
                lineTo(3.797f, 11.361f)
                curveTo(3.726f, 11.205f, 3.705f, 11.063f, 3.764f, 10.928f)
                lineTo(4.268f, 11.147f)
                curveTo(4.285f, 11.108f, 4.285f, 11.106f, 4.298f, 11.135f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(2.045f, 0.382f)
                curveTo(2.013f, 0.147f, 2.164f, -0.021f, 2.416f, -0.129f)
                curveTo(2.756f, -0.273f, 3.098f, -0.138f, 3.413f, 0.211f)
                lineTo(3.005f, 0.58f)
                curveTo(2.865f, 0.425f, 2.764f, 0.365f, 2.686f, 0.366f)
                curveTo(2.839f, 0.475f, 3.035f, 0.61f, 3.273f, 0.77f)
                lineTo(3.388f, 0.936f)
                curveTo(3.48f, 1.331f, 3.194f, 1.544f, 2.758f, 1.544f)
                curveTo(2.501f, 1.544f, 2.295f, 1.494f, 2.165f, 1.384f)
                curveTo(1.951f, 1.205f, 1.988f, 0.918f, 2.213f, 0.769f)
                curveTo(2.231f, 0.757f, 2.249f, 0.747f, 2.267f, 0.737f)
                curveTo(2.141f, 0.631f, 2.064f, 0.52f, 2.045f, 0.382f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(4.285f, 0.382f)
                curveTo(4.317f, 0.147f, 4.166f, -0.021f, 3.913f, -0.129f)
                curveTo(3.574f, -0.273f, 3.232f, -0.138f, 2.916f, 0.211f)
                lineTo(3.325f, 0.58f)
                curveTo(3.465f, 0.425f, 3.566f, 0.365f, 3.644f, 0.366f)
                curveTo(3.491f, 0.475f, 3.295f, 0.61f, 3.057f, 0.77f)
                lineTo(2.942f, 0.936f)
                curveTo(2.85f, 1.331f, 3.136f, 1.544f, 3.572f, 1.544f)
                curveTo(3.829f, 1.544f, 4.034f, 1.494f, 4.165f, 1.384f)
                curveTo(4.379f, 1.205f, 4.342f, 0.918f, 4.117f, 0.769f)
                curveTo(4.099f, 0.757f, 4.081f, 0.747f, 4.063f, 0.737f)
                curveTo(4.189f, 0.631f, 4.266f, 0.52f, 4.285f, 0.382f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.547f, 10.031f)
                curveTo(2.231f, 10.041f, 2.035f, 10.106f, 2.035f, 10.41f)
                curveTo(2.035f, 10.745f, 2.361f, 10.85f, 2.708f, 10.85f)
                curveTo(3.022f, 10.85f, 3.375f, 10.655f, 3.375f, 10.306f)
                curveTo(3.375f, 10.094f, 3.105f, 9.665f, 2.426f, 8.737f)
                curveTo(2.402f, 8.715f, 2.389f, 8.703f, 2.379f, 8.703f)
                curveTo(2.42f, 8.68f, 2.492f, 8.653f, 2.588f, 8.653f)
                curveTo(2.622f, 8.653f, 2.665f, 8.67f, 2.708f, 8.692f)
                verticalLineTo(9.056f)
                horizontalLineTo(3.427f)
                verticalLineTo(8.781f)
                curveTo(3.427f, 8.47f, 2.968f, 8.103f, 2.588f, 8.103f)
                curveTo(2.257f, 8.103f, 1.99f, 8.261f, 1.855f, 8.488f)
                curveTo(1.722f, 8.713f, 1.824f, 8.928f, 2.015f, 9.099f)
                curveTo(2.3f, 9.492f, 2.521f, 9.817f, 2.66f, 10.031f)
                curveTo(2.609f, 10.03f, 2.581f, 10.031f, 2.547f, 10.031f)
                close()
                moveTo(2.581f, 10.285f)
                curveTo(2.571f, 10.283f, 2.561f, 10.28f, 2.552f, 10.278f)
                curveTo(2.559f, 10.285f, 2.585f, 10.316f, 2.585f, 10.41f)
                curveTo(2.585f, 10.461f, 2.583f, 10.497f, 2.579f, 10.522f)
                curveTo(2.487f, 10.44f, 2.461f, 10.297f, 2.529f, 10.188f)
                lineTo(2.53f, 10.185f)
                lineTo(2.52f, 10.164f)
                curveTo(2.521f, 10.163f, 2.523f, 10.163f, 2.524f, 10.162f)
                curveTo(2.54f, 10.154f, 2.553f, 10.147f, 2.53f, 10.185f)
                lineTo(2.581f, 10.285f)
                close()
                moveTo(2.552f, 10.278f)
                lineTo(2.543f, 10.275f)
                curveTo(2.544f, 10.275f, 2.545f, 10.276f, 2.547f, 10.277f)
                lineTo(2.552f, 10.278f)
                close()
                moveTo(2.825f, 10.306f)
                curveTo(2.825f, 10.297f, 2.822f, 10.291f, 2.817f, 10.288f)
                lineTo(2.82f, 10.292f)
                curveTo(2.823f, 10.299f, 2.825f, 10.304f, 2.825f, 10.306f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.783f, 10.031f)
                curveTo(4.098f, 10.041f, 4.295f, 10.106f, 4.295f, 10.41f)
                curveTo(4.295f, 10.745f, 3.969f, 10.85f, 3.622f, 10.85f)
                curveTo(3.308f, 10.85f, 2.954f, 10.655f, 2.954f, 10.306f)
                curveTo(2.954f, 10.094f, 3.224f, 9.665f, 3.904f, 8.737f)
                curveTo(3.928f, 8.715f, 3.941f, 8.703f, 3.951f, 8.703f)
                curveTo(3.91f, 8.68f, 3.837f, 8.653f, 3.741f, 8.653f)
                curveTo(3.708f, 8.653f, 3.665f, 8.67f, 3.622f, 8.692f)
                verticalLineTo(9.056f)
                horizontalLineTo(2.902f)
                verticalLineTo(8.781f)
                curveTo(2.902f, 8.47f, 3.362f, 8.103f, 3.741f, 8.103f)
                curveTo(4.073f, 8.103f, 4.339f, 8.261f, 4.474f, 8.488f)
                curveTo(4.608f, 8.713f, 4.506f, 8.928f, 4.314f, 9.099f)
                curveTo(4.029f, 9.492f, 3.808f, 9.817f, 3.67f, 10.031f)
                curveTo(3.72f, 10.03f, 3.748f, 10.031f, 3.783f, 10.031f)
                close()
                moveTo(3.749f, 10.285f)
                curveTo(3.759f, 10.283f, 3.769f, 10.28f, 3.778f, 10.278f)
                curveTo(3.771f, 10.285f, 3.745f, 10.316f, 3.745f, 10.41f)
                curveTo(3.745f, 10.461f, 3.747f, 10.497f, 3.75f, 10.522f)
                curveTo(3.843f, 10.44f, 3.869f, 10.297f, 3.801f, 10.188f)
                lineTo(3.8f, 10.185f)
                lineTo(3.81f, 10.164f)
                curveTo(3.808f, 10.163f, 3.807f, 10.163f, 3.806f, 10.162f)
                curveTo(3.79f, 10.154f, 3.777f, 10.147f, 3.8f, 10.185f)
                lineTo(3.749f, 10.285f)
                close()
                moveTo(3.778f, 10.278f)
                lineTo(3.787f, 10.275f)
                curveTo(3.786f, 10.275f, 3.785f, 10.276f, 3.783f, 10.277f)
                lineTo(3.778f, 10.278f)
                close()
                moveTo(3.504f, 10.306f)
                curveTo(3.504f, 10.297f, 3.508f, 10.291f, 3.513f, 10.288f)
                lineTo(3.51f, 10.292f)
                curveTo(3.506f, 10.299f, 3.504f, 10.304f, 3.504f, 10.306f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.547f, 6.677f)
                curveTo(2.231f, 6.668f, 2.035f, 6.603f, 2.035f, 6.299f)
                curveTo(2.035f, 5.964f, 2.361f, 5.859f, 2.708f, 5.859f)
                curveTo(3.022f, 5.859f, 3.375f, 6.054f, 3.375f, 6.403f)
                curveTo(3.375f, 6.615f, 3.105f, 7.043f, 2.426f, 7.972f)
                curveTo(2.402f, 7.994f, 2.389f, 8.005f, 2.379f, 8.006f)
                curveTo(2.42f, 8.028f, 2.492f, 8.055f, 2.588f, 8.055f)
                curveTo(2.622f, 8.055f, 2.665f, 8.039f, 2.708f, 8.017f)
                verticalLineTo(7.653f)
                horizontalLineTo(3.427f)
                verticalLineTo(7.928f)
                curveTo(3.427f, 8.238f, 2.968f, 8.605f, 2.588f, 8.605f)
                curveTo(2.257f, 8.605f, 1.99f, 8.448f, 1.855f, 8.221f)
                curveTo(1.722f, 7.996f, 1.824f, 7.781f, 2.015f, 7.61f)
                curveTo(2.3f, 7.217f, 2.521f, 6.892f, 2.66f, 6.678f)
                curveTo(2.609f, 6.678f, 2.581f, 6.678f, 2.547f, 6.677f)
                close()
                moveTo(2.581f, 6.424f)
                curveTo(2.571f, 6.426f, 2.561f, 6.428f, 2.552f, 6.431f)
                curveTo(2.559f, 6.424f, 2.585f, 6.393f, 2.585f, 6.299f)
                curveTo(2.585f, 6.248f, 2.583f, 6.212f, 2.579f, 6.187f)
                curveTo(2.487f, 6.269f, 2.461f, 6.412f, 2.529f, 6.521f)
                lineTo(2.53f, 6.524f)
                lineTo(2.52f, 6.545f)
                curveTo(2.521f, 6.545f, 2.523f, 6.546f, 2.524f, 6.547f)
                curveTo(2.54f, 6.555f, 2.553f, 6.562f, 2.53f, 6.524f)
                lineTo(2.581f, 6.424f)
                close()
                moveTo(2.552f, 6.431f)
                lineTo(2.543f, 6.434f)
                curveTo(2.544f, 6.434f, 2.545f, 6.433f, 2.547f, 6.432f)
                lineTo(2.552f, 6.431f)
                close()
                moveTo(2.825f, 6.403f)
                curveTo(2.825f, 6.412f, 2.822f, 6.418f, 2.817f, 6.421f)
                lineTo(2.82f, 6.417f)
                curveTo(2.823f, 6.41f, 2.825f, 6.405f, 2.825f, 6.403f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.783f, 6.677f)
                curveTo(4.098f, 6.668f, 4.295f, 6.603f, 4.295f, 6.299f)
                curveTo(4.295f, 5.964f, 3.969f, 5.859f, 3.622f, 5.859f)
                curveTo(3.308f, 5.859f, 2.954f, 6.054f, 2.954f, 6.403f)
                curveTo(2.954f, 6.615f, 3.224f, 7.043f, 3.904f, 7.972f)
                curveTo(3.928f, 7.994f, 3.941f, 8.005f, 3.951f, 8.006f)
                curveTo(3.91f, 8.028f, 3.837f, 8.055f, 3.741f, 8.055f)
                curveTo(3.708f, 8.055f, 3.665f, 8.039f, 3.622f, 8.017f)
                verticalLineTo(7.653f)
                horizontalLineTo(2.902f)
                verticalLineTo(7.928f)
                curveTo(2.902f, 8.238f, 3.362f, 8.605f, 3.741f, 8.605f)
                curveTo(4.073f, 8.605f, 4.339f, 8.448f, 4.474f, 8.221f)
                curveTo(4.608f, 7.996f, 4.506f, 7.781f, 4.314f, 7.61f)
                curveTo(4.029f, 7.217f, 3.808f, 6.892f, 3.67f, 6.678f)
                curveTo(3.72f, 6.678f, 3.748f, 6.678f, 3.783f, 6.677f)
                close()
                moveTo(3.749f, 6.424f)
                curveTo(3.759f, 6.426f, 3.769f, 6.428f, 3.778f, 6.431f)
                curveTo(3.771f, 6.424f, 3.745f, 6.393f, 3.745f, 6.299f)
                curveTo(3.745f, 6.248f, 3.747f, 6.212f, 3.75f, 6.187f)
                curveTo(3.843f, 6.269f, 3.869f, 6.412f, 3.801f, 6.521f)
                lineTo(3.8f, 6.524f)
                lineTo(3.81f, 6.545f)
                curveTo(3.808f, 6.545f, 3.807f, 6.546f, 3.806f, 6.547f)
                curveTo(3.79f, 6.555f, 3.777f, 6.562f, 3.8f, 6.524f)
                lineTo(3.749f, 6.424f)
                close()
                moveTo(3.778f, 6.431f)
                lineTo(3.787f, 6.434f)
                curveTo(3.786f, 6.434f, 3.785f, 6.433f, 3.783f, 6.432f)
                lineTo(3.778f, 6.431f)
                close()
                moveTo(3.504f, 6.403f)
                curveTo(3.504f, 6.412f, 3.508f, 6.418f, 3.513f, 6.421f)
                lineTo(3.51f, 6.417f)
                curveTo(3.506f, 6.41f, 3.504f, 6.405f, 3.504f, 6.403f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.547f, 5.323f)
                curveTo(2.231f, 5.332f, 2.035f, 5.397f, 2.035f, 5.701f)
                curveTo(2.035f, 6.036f, 2.361f, 6.141f, 2.708f, 6.141f)
                curveTo(3.022f, 6.141f, 3.375f, 5.946f, 3.375f, 5.597f)
                curveTo(3.375f, 5.385f, 3.105f, 4.957f, 2.426f, 4.028f)
                curveTo(2.402f, 4.006f, 2.389f, 3.995f, 2.379f, 3.994f)
                curveTo(2.42f, 3.971f, 2.492f, 3.945f, 2.588f, 3.945f)
                curveTo(2.622f, 3.945f, 2.665f, 3.961f, 2.708f, 3.983f)
                verticalLineTo(4.347f)
                horizontalLineTo(3.427f)
                verticalLineTo(4.072f)
                curveTo(3.427f, 3.762f, 2.968f, 3.395f, 2.588f, 3.395f)
                curveTo(2.257f, 3.395f, 1.99f, 3.552f, 1.855f, 3.779f)
                curveTo(1.722f, 4.004f, 1.824f, 4.219f, 2.015f, 4.39f)
                curveTo(2.3f, 4.783f, 2.521f, 5.108f, 2.66f, 5.322f)
                curveTo(2.609f, 5.322f, 2.581f, 5.322f, 2.547f, 5.323f)
                close()
                moveTo(2.581f, 5.576f)
                curveTo(2.571f, 5.574f, 2.561f, 5.572f, 2.552f, 5.569f)
                curveTo(2.559f, 5.576f, 2.585f, 5.607f, 2.585f, 5.701f)
                curveTo(2.585f, 5.752f, 2.583f, 5.788f, 2.579f, 5.813f)
                curveTo(2.487f, 5.731f, 2.461f, 5.588f, 2.529f, 5.479f)
                lineTo(2.53f, 5.476f)
                lineTo(2.52f, 5.455f)
                curveTo(2.521f, 5.455f, 2.523f, 5.454f, 2.524f, 5.453f)
                curveTo(2.54f, 5.445f, 2.553f, 5.438f, 2.53f, 5.476f)
                lineTo(2.581f, 5.576f)
                close()
                moveTo(2.552f, 5.569f)
                lineTo(2.543f, 5.566f)
                curveTo(2.544f, 5.566f, 2.545f, 5.567f, 2.547f, 5.568f)
                lineTo(2.552f, 5.569f)
                close()
                moveTo(2.825f, 5.597f)
                curveTo(2.825f, 5.588f, 2.822f, 5.582f, 2.817f, 5.579f)
                lineTo(2.82f, 5.583f)
                curveTo(2.823f, 5.59f, 2.825f, 5.595f, 2.825f, 5.597f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.783f, 5.323f)
                curveTo(4.098f, 5.332f, 4.295f, 5.397f, 4.295f, 5.701f)
                curveTo(4.295f, 6.036f, 3.969f, 6.141f, 3.622f, 6.141f)
                curveTo(3.308f, 6.141f, 2.954f, 5.946f, 2.954f, 5.597f)
                curveTo(2.954f, 5.385f, 3.224f, 4.957f, 3.904f, 4.028f)
                curveTo(3.928f, 4.006f, 3.941f, 3.995f, 3.951f, 3.994f)
                curveTo(3.91f, 3.971f, 3.837f, 3.945f, 3.741f, 3.945f)
                curveTo(3.708f, 3.945f, 3.665f, 3.961f, 3.622f, 3.983f)
                verticalLineTo(4.347f)
                horizontalLineTo(2.902f)
                verticalLineTo(4.072f)
                curveTo(2.902f, 3.762f, 3.362f, 3.395f, 3.741f, 3.395f)
                curveTo(4.073f, 3.395f, 4.339f, 3.552f, 4.474f, 3.779f)
                curveTo(4.608f, 4.004f, 4.506f, 4.219f, 4.314f, 4.39f)
                curveTo(4.029f, 4.783f, 3.808f, 5.108f, 3.67f, 5.322f)
                curveTo(3.72f, 5.322f, 3.748f, 5.322f, 3.783f, 5.323f)
                close()
                moveTo(3.749f, 5.576f)
                curveTo(3.759f, 5.574f, 3.769f, 5.572f, 3.778f, 5.569f)
                curveTo(3.771f, 5.576f, 3.745f, 5.607f, 3.745f, 5.701f)
                curveTo(3.745f, 5.752f, 3.747f, 5.788f, 3.75f, 5.813f)
                curveTo(3.843f, 5.731f, 3.869f, 5.588f, 3.801f, 5.479f)
                lineTo(3.8f, 5.476f)
                lineTo(3.81f, 5.455f)
                curveTo(3.808f, 5.455f, 3.807f, 5.454f, 3.806f, 5.453f)
                curveTo(3.79f, 5.445f, 3.777f, 5.438f, 3.8f, 5.476f)
                lineTo(3.749f, 5.576f)
                close()
                moveTo(3.778f, 5.569f)
                lineTo(3.787f, 5.566f)
                curveTo(3.786f, 5.566f, 3.785f, 5.567f, 3.783f, 5.568f)
                lineTo(3.778f, 5.569f)
                close()
                moveTo(3.504f, 5.597f)
                curveTo(3.504f, 5.588f, 3.508f, 5.582f, 3.513f, 5.579f)
                lineTo(3.51f, 5.583f)
                curveTo(3.506f, 5.59f, 3.504f, 5.595f, 3.504f, 5.597f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.547f, 1.969f)
                curveTo(2.231f, 1.959f, 2.035f, 1.894f, 2.035f, 1.59f)
                curveTo(2.035f, 1.255f, 2.361f, 1.15f, 2.708f, 1.15f)
                curveTo(3.022f, 1.15f, 3.375f, 1.345f, 3.375f, 1.694f)
                curveTo(3.375f, 1.906f, 3.105f, 2.335f, 2.426f, 3.263f)
                curveTo(2.402f, 3.285f, 2.389f, 3.297f, 2.379f, 3.297f)
                curveTo(2.42f, 3.32f, 2.492f, 3.347f, 2.588f, 3.347f)
                curveTo(2.622f, 3.347f, 2.665f, 3.33f, 2.708f, 3.308f)
                verticalLineTo(2.944f)
                horizontalLineTo(3.427f)
                verticalLineTo(3.219f)
                curveTo(3.427f, 3.53f, 2.968f, 3.897f, 2.588f, 3.897f)
                curveTo(2.257f, 3.897f, 1.99f, 3.739f, 1.855f, 3.512f)
                curveTo(1.722f, 3.287f, 1.824f, 3.072f, 2.015f, 2.901f)
                curveTo(2.3f, 2.508f, 2.521f, 2.183f, 2.66f, 1.969f)
                curveTo(2.609f, 1.97f, 2.581f, 1.969f, 2.547f, 1.969f)
                close()
                moveTo(2.581f, 1.715f)
                curveTo(2.571f, 1.717f, 2.561f, 1.72f, 2.552f, 1.722f)
                curveTo(2.559f, 1.715f, 2.585f, 1.684f, 2.585f, 1.59f)
                curveTo(2.585f, 1.539f, 2.583f, 1.503f, 2.579f, 1.478f)
                curveTo(2.487f, 1.56f, 2.461f, 1.703f, 2.529f, 1.813f)
                lineTo(2.53f, 1.815f)
                lineTo(2.52f, 1.836f)
                curveTo(2.521f, 1.837f, 2.523f, 1.837f, 2.524f, 1.838f)
                curveTo(2.54f, 1.846f, 2.553f, 1.853f, 2.53f, 1.815f)
                lineTo(2.581f, 1.715f)
                close()
                moveTo(2.552f, 1.722f)
                lineTo(2.543f, 1.725f)
                curveTo(2.544f, 1.725f, 2.545f, 1.724f, 2.547f, 1.723f)
                lineTo(2.552f, 1.722f)
                close()
                moveTo(2.825f, 1.694f)
                curveTo(2.825f, 1.703f, 2.822f, 1.709f, 2.817f, 1.712f)
                lineTo(2.82f, 1.708f)
                curveTo(2.823f, 1.701f, 2.825f, 1.696f, 2.825f, 1.694f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.783f, 1.969f)
                curveTo(4.098f, 1.959f, 4.295f, 1.894f, 4.295f, 1.59f)
                curveTo(4.295f, 1.255f, 3.969f, 1.15f, 3.622f, 1.15f)
                curveTo(3.308f, 1.15f, 2.954f, 1.345f, 2.954f, 1.694f)
                curveTo(2.954f, 1.906f, 3.224f, 2.335f, 3.904f, 3.263f)
                curveTo(3.928f, 3.285f, 3.941f, 3.297f, 3.951f, 3.297f)
                curveTo(3.91f, 3.32f, 3.837f, 3.347f, 3.741f, 3.347f)
                curveTo(3.708f, 3.347f, 3.665f, 3.33f, 3.622f, 3.308f)
                verticalLineTo(2.944f)
                horizontalLineTo(2.902f)
                verticalLineTo(3.219f)
                curveTo(2.902f, 3.53f, 3.362f, 3.897f, 3.741f, 3.897f)
                curveTo(4.073f, 3.897f, 4.339f, 3.739f, 4.474f, 3.512f)
                curveTo(4.608f, 3.287f, 4.506f, 3.072f, 4.314f, 2.901f)
                curveTo(4.029f, 2.508f, 3.808f, 2.183f, 3.67f, 1.969f)
                curveTo(3.72f, 1.97f, 3.748f, 1.969f, 3.783f, 1.969f)
                close()
                moveTo(3.749f, 1.715f)
                curveTo(3.759f, 1.717f, 3.769f, 1.72f, 3.778f, 1.722f)
                curveTo(3.771f, 1.715f, 3.745f, 1.684f, 3.745f, 1.59f)
                curveTo(3.745f, 1.539f, 3.747f, 1.503f, 3.75f, 1.478f)
                curveTo(3.843f, 1.56f, 3.869f, 1.703f, 3.801f, 1.813f)
                lineTo(3.8f, 1.815f)
                lineTo(3.81f, 1.836f)
                curveTo(3.808f, 1.837f, 3.807f, 1.837f, 3.806f, 1.838f)
                curveTo(3.79f, 1.846f, 3.777f, 1.853f, 3.8f, 1.815f)
                lineTo(3.749f, 1.715f)
                close()
                moveTo(3.778f, 1.722f)
                lineTo(3.787f, 1.725f)
                curveTo(3.786f, 1.725f, 3.785f, 1.724f, 3.783f, 1.723f)
                lineTo(3.778f, 1.722f)
                close()
                moveTo(3.504f, 1.694f)
                curveTo(3.504f, 1.703f, 3.508f, 1.709f, 3.513f, 1.712f)
                lineTo(3.51f, 1.708f)
                curveTo(3.506f, 1.701f, 3.504f, 1.696f, 3.504f, 1.694f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.493f, 1.392f)
                lineTo(9.698f, 2.156f)
                curveTo(9.698f, 2.156f, 9.701f, 2.33f, 9.505f, 2.33f)
                curveTo(9.308f, 2.33f, 9.299f, 2.156f, 9.299f, 2.156f)
                lineTo(9.493f, 1.392f)
                close()
                moveTo(11.225f, 4.31f)
                curveTo(11.225f, 5.304f, 10.466f, 6.11f, 9.53f, 6.11f)
                curveTo(8.594f, 6.11f, 7.835f, 5.304f, 7.835f, 4.31f)
                curveTo(7.835f, 3.316f, 8.594f, 2.51f, 9.53f, 2.51f)
                curveTo(10.466f, 2.51f, 11.225f, 3.316f, 11.225f, 4.31f)
                close()
                moveTo(10.291f, 2.31f)
                lineTo(10.318f, 1.52f)
                lineTo(9.909f, 2.193f)
                curveTo(9.909f, 2.193f, 9.867f, 2.362f, 10.055f, 2.42f)
                curveTo(10.242f, 2.477f, 10.291f, 2.31f, 10.291f, 2.31f)
                close()
                moveTo(11.07f, 1.894f)
                lineTo(10.813f, 2.642f)
                curveTo(10.813f, 2.642f, 10.718f, 2.787f, 10.555f, 2.678f)
                curveTo(10.393f, 2.568f, 10.482f, 2.419f, 10.482f, 2.419f)
                lineTo(11.07f, 1.894f)
                close()
                moveTo(11.218f, 3.122f)
                lineTo(11.683f, 2.482f)
                lineTo(10.967f, 2.811f)
                curveTo(10.967f, 2.811f, 10.838f, 2.928f, 10.962f, 3.081f)
                curveTo(11.085f, 3.233f, 11.218f, 3.122f, 11.218f, 3.122f)
                close()
                moveTo(12.106f, 3.239f)
                lineTo(11.466f, 3.704f)
                curveTo(11.466f, 3.704f, 11.305f, 3.768f, 11.234f, 3.585f)
                curveTo(11.164f, 3.402f, 11.323f, 3.331f, 11.323f, 3.331f)
                lineTo(12.106f, 3.239f)
                close()
                moveTo(11.544f, 4.341f)
                lineTo(12.292f, 4.084f)
                lineTo(11.516f, 3.943f)
                curveTo(11.516f, 3.943f, 11.344f, 3.964f, 11.357f, 4.16f)
                curveTo(11.371f, 4.356f, 11.544f, 4.341f, 11.544f, 4.341f)
                close()
                moveTo(12.23f, 4.948f)
                lineTo(11.44f, 4.976f)
                curveTo(11.44f, 4.976f, 11.27f, 4.939f, 11.314f, 4.748f)
                curveTo(11.359f, 4.557f, 11.53f, 4.586f, 11.53f, 4.586f)
                lineTo(12.23f, 4.948f)
                close()
                moveTo(11.163f, 5.551f)
                lineTo(11.927f, 5.755f)
                lineTo(11.363f, 5.205f)
                curveTo(11.363f, 5.205f, 11.208f, 5.126f, 11.109f, 5.296f)
                curveTo(11.012f, 5.466f, 11.163f, 5.551f, 11.163f, 5.551f)
                close()
                moveTo(11.408f, 6.434f)
                lineTo(10.738f, 6.015f)
                curveTo(10.738f, 6.015f, 10.617f, 5.89f, 10.761f, 5.756f)
                curveTo(10.904f, 5.622f, 11.03f, 5.742f, 11.03f, 5.742f)
                lineTo(11.408f, 6.434f)
                close()
                moveTo(10.201f, 6.327f)
                lineTo(10.72f, 6.924f)
                lineTo(10.561f, 6.152f)
                curveTo(10.561f, 6.152f, 10.476f, 6f, 10.3f, 6.086f)
                curveTo(10.123f, 6.172f, 10.201f, 6.327f, 10.201f, 6.327f)
                close()
                moveTo(9.924f, 7.181f)
                lineTo(9.603f, 6.459f)
                curveTo(9.603f, 6.459f, 9.573f, 6.288f, 9.767f, 6.257f)
                curveTo(9.96f, 6.227f, 9.997f, 6.396f, 9.997f, 6.396f)
                lineTo(9.924f, 7.181f)
                close()
                moveTo(9f, 6.396f)
                lineTo(9.082f, 7.183f)
                lineTo(9.394f, 6.459f)
                curveTo(9.394f, 6.459f, 9.412f, 6.286f, 9.218f, 6.255f)
                curveTo(9.024f, 6.225f, 9f, 6.396f, 9f, 6.396f)
                close()
                moveTo(8.285f, 6.928f)
                lineTo(8.436f, 6.152f)
                curveTo(8.436f, 6.152f, 8.51f, 5.995f, 8.686f, 6.081f)
                curveTo(8.862f, 6.167f, 8.795f, 6.327f, 8.795f, 6.327f)
                lineTo(8.285f, 6.928f)
                close()
                moveTo(7.967f, 5.742f)
                lineTo(7.596f, 6.441f)
                lineTo(8.259f, 6.015f)
                curveTo(8.259f, 6.015f, 8.37f, 5.881f, 8.227f, 5.747f)
                curveTo(8.084f, 5.614f, 7.967f, 5.742f, 7.967f, 5.742f)
                close()
                moveTo(7.075f, 5.764f)
                lineTo(7.634f, 5.205f)
                curveTo(7.634f, 5.205f, 7.783f, 5.116f, 7.881f, 5.285f)
                curveTo(7.979f, 5.455f, 7.834f, 5.551f, 7.834f, 5.551f)
                lineTo(7.075f, 5.764f)
                close()
                moveTo(7.467f, 4.586f)
                lineTo(6.769f, 4.958f)
                lineTo(7.557f, 4.976f)
                curveTo(7.557f, 4.976f, 7.724f, 4.927f, 7.68f, 4.736f)
                curveTo(7.635f, 4.545f, 7.467f, 4.586f, 7.467f, 4.586f)
                close()
                moveTo(6.704f, 4.093f)
                lineTo(7.481f, 3.943f)
                curveTo(7.481f, 3.943f, 7.654f, 3.952f, 7.64f, 4.148f)
                curveTo(7.627f, 4.343f, 7.453f, 4.341f, 7.453f, 4.341f)
                lineTo(6.704f, 4.093f)
                close()
                moveTo(7.674f, 3.331f)
                lineTo(6.888f, 3.248f)
                lineTo(7.531f, 3.704f)
                curveTo(7.531f, 3.704f, 7.696f, 3.757f, 7.767f, 3.574f)
                curveTo(7.837f, 3.391f, 7.674f, 3.331f, 7.674f, 3.331f)
                close()
                moveTo(7.307f, 2.49f)
                lineTo(8.03f, 2.811f)
                curveTo(8.03f, 2.811f, 8.166f, 2.919f, 8.043f, 3.071f)
                curveTo(7.919f, 3.223f, 7.778f, 3.122f, 7.778f, 3.122f)
                lineTo(7.307f, 2.49f)
                close()
                moveTo(8.515f, 2.419f)
                lineTo(7.918f, 1.9f)
                lineTo(8.184f, 2.642f)
                curveTo(8.184f, 2.642f, 8.289f, 2.78f, 8.452f, 2.671f)
                curveTo(8.614f, 2.561f, 8.515f, 2.419f, 8.515f, 2.419f)
                close()
                moveTo(8.669f, 1.523f)
                lineTo(9.088f, 2.193f)
                curveTo(9.088f, 2.193f, 9.141f, 2.359f, 8.954f, 2.416f)
                curveTo(8.766f, 2.473f, 8.706f, 2.31f, 8.706f, 2.31f)
                lineTo(8.669f, 1.523f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(5.774f, 4f)
                lineTo(6.495f, 4.073f)
                curveTo(6.149f, 6.42f, 7.083f, 7.477f, 9.514f, 7.477f)
                curveTo(11.974f, 7.477f, 13.113f, 6.372f, 13.113f, 4f)
                curveTo(13.113f, 4f, 13.626f, 3.971f, 13.622f, 4.073f)
                curveTo(13.511f, 6.802f, 12.34f, 8.554f, 9.442f, 8.554f)
                curveTo(6.406f, 8.554f, 5.338f, 6.956f, 5.774f, 4f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(5.989f, 5.4f)
                lineTo(6.671f, 5.473f)
                curveTo(6.344f, 7.82f, 7.226f, 8.877f, 9.521f, 8.877f)
                curveTo(11.845f, 8.877f, 12.921f, 7.772f, 12.921f, 5.4f)
                curveTo(12.921f, 5.4f, 13.405f, 5.371f, 13.401f, 5.473f)
                curveTo(13.297f, 8.202f, 12.19f, 9.954f, 9.454f, 9.954f)
                curveTo(6.587f, 9.954f, 5.577f, 8.356f, 5.989f, 5.4f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun KazakhstanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Kazakhstan,
            contentDescription = "Kazakhstan Flag"
        )
    }
}
